module.exports = __webpack_public_path__ + "img/ltkfit-4x.071f5c0.jpg";